export function deriveCurrentOption(location){
    return location.pathname.split("/")[2];
}